module.exports = "<div class=\"sso container\">\n    <div class=\"hp-loading-spinner\" ra-spinner name=\"ssoLoadingSpinner\" hide-content-when-shown=\"true\" show=\"true\">\n\n    </div>\n    \n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/topNav/sso.html
// module id = 960
// module chunks = 1